<template>
  <activtyList :orgType="orgType"/>
</template>
<script>
import ActivtyList from './ActivityList.vue';
export default {
  name:'schoolActivtyList',
  data(){
    return{
      orgType:2,//1平台活动2学校活动3课程方活动
    }
  },
  components:{
    ActivtyList
  }
}
</script>